import { useState } from "react";
import axiosInstance from "@/hooks/axios";
import { isAxiosError } from "axios";
import { User } from "@/types/user";

export interface LoginUserData {
  email: User["email"];
  password: string;
}

export interface LoginUserResponse {
  success: boolean;
  message: string;
  user: {
    id: User["id"];
    email: User["email"];
    sign_in_count: number;
    failed_attempts: number;
  };
  access_token: string;
  refresh_token: string;
}

export const useLoginUser = () => {
  const [data, setData] = useState<LoginUserResponse | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const loginUser = async (loginData: LoginUserData) => {
    setLoading(true);
    setError(null);
    try {
      const response = await axiosInstance.post<LoginUserResponse>(
        "users/users/login/",
        loginData,
      );
      setData(response.data);
    } catch (err: unknown) {
      if (isAxiosError(err)) {
        setError(err.message);
      } else if (err instanceof Error) {
        setError(err.message);
      } else {
        setError("An unknown error occurred.");
      }
    } finally {
      setLoading(false);
    }
  };

  return { data, loading, error, loginUser };
};
